import React, { Component } from 'react';
import styled from 'styled-components/macro';
import ForgotPasswordUpdateForm from './forms/ForgotPasswordUpdateForm';
import MyS4CUnAuthNav from './MyS4CUnAuthNav';
import translate from '../TranslateHOC';
import { device } from '../../v2/Theme';
import { rgba } from 'polished';

class MyS4CForgotPasswordUpdate extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    const { strings, isAuthenticated } = this.props;
    const activeLocation = this.props.location.pathname;
    const verifyCode = this.props.match.params.verifyCode;
    const email = this.props.match.params.email;

    return (
      <div className="sign-in">
        <ForgotPasswordUpdateFormContainer>
          {!isAuthenticated && <MyS4CUnAuthNav active={activeLocation} />}
          <ForgotPasswordUpdateForm
            strings={strings}
            email={email}
            code={verifyCode}
            history={this.props.history}
            isAuthenticated={isAuthenticated}
          />
        </ForgotPasswordUpdateFormContainer>
        <BackgroundImage className="my-s4c-content__bg" />
      </div>
    );
  }
}

const ForgotPasswordUpdateFormContainer = styled.section`
  background: ${(props) =>
    props.theme.name === 'light'
      ? 'rgba(251, 251, 251, 0.6);'
      : 'rgba(16, 16, 15, 0.6);'};
  border-radius: 12px;
  box-shadow: ${(props) =>
    props.theme.name === 'light'
      ? '0px 32px 64px rgba(0, 0, 0, 0.075), 0px 16px 32px rgba(0, 0, 0, 0.075), 0px 8px 16px rgba(0, 0, 0, 0.075), 0px 4px 8px rgba(0, 0, 0, 0.075)'
      : '0px 32px 64px rgba(0, 0, 0, 0.075), 0px 16px 32px rgba(0, 0, 0, 0.075), 0px 8px 16px rgba(0, 0, 0, 0.075), 0px 4px 8px rgba(0, 0, 0, 0.075)'};
  backdrop-filter: blur(24px);
  margin: 4.5em 20px;
  max-width: 474px;
  width: calc(100% - 40px);
  z-index: 9999;
  position: relative;
  left: 50%;
  margin-left: 0;
  margin-right: 0;
  margin-top: 8em;
  transform: translateX(-50%);
  @media ${device.tablet} {
    margin-top: 12px;
    .form {
      margin-bottom: 11em;
    }
  }
  .sub-header {
    background: none;
    border-radius: 12px 12px 0 0;
    box-shadow: none;

    .my-s4c-header {
      margin: 0;
    }
  }
  .sub-header a {
    padding-bottom: 23px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull} !important;
    font-size: 18px;
    line-height: 27px;
    &:hover {
      box-shadow: none;
    }
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      border-radius: 4px;
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
  }
  .my-s4c-header__nav--unauth {
    padding-left: 20px !important;
  }
  .my-s4c-header__link--active {
    font-weight: bold;
    &::before {
      bottom: -3px;
      left: 0;
      right: 0;
    }
  }
  .form {
    margin-bottom: 5em;
    max-width: none;
  }
  .form__header {
    margin-top: 5px;
    margin-bottom: 24px;
    padding: 0 20px;
  }
  .form--no-btm-pad {
    padding-bottom: 2px;
  }
  .form__instruct--pad-btm {
    padding-bottom: 24px;
  }
  .form__label {
    font-size: 20px;
    line-height: 24px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
  }
  .form__input {
    line-height: 22px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
    &::-webkit-input-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &::-moz-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &:-ms-input-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    &:-moz-placeholder {
      color: ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.black75
          : props.theme.color.white75};
    }
    background: ${(props) =>
      props.theme.name === 'light'
        ? 'rgba(16, 16, 15, 0.05);'
        : 'rgba(255, 255, 255, 0.05);'};
    border: 1px solid
      ${(props) =>
        props.theme.name === 'light'
          ? 'rgba(0, 0, 0, 0.1)'
          : 'rgba(255, 255, 255, 0.2);'};
    box-shadow: none;
    &:hover,
    &:active,
    &:focus-visible {
      color: ${(props) =>
        props.theme.name === 'dark' && props.theme.color.whiteFull};
    }
    &:focus-visible {
      box-shadow: ${(props) => props.theme.focusRing};
      outline: none;
    }
    &:focus:not(:focus-visible) {
      outline: none;
    }
  }
  .form__forgot {
    position: relative;
    margin: 0 20px 37px;
    font-size: 20px;
    line-height: 24px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.primaryAAA
        : props.theme.color.primaryFull};
    &:after {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 1px;
      border-width: 0 0 1px;
      border-style: solid;
      content: '';
    }
  }
  .form__actions > div {
    justify-content: center;
  }
  .alert-error {
    margin-bottom: 23px;
    color: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.blackFull
        : props.theme.color.whiteFull};
  }
`;

const BackgroundImage = styled.div`
  max-height: 800px;
  &:before {
    background: ${(props) =>
      props.theme.name === 'light'
        ? props.theme.color.whiteFull
        : props.theme.color.blackFull};
    content: '';
    display: block;
    height: 100%;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    transition: opacity 75ms ease;
  }
  &:after {
    background: ${(props) =>
      props.theme.name === 'light'
        ? `
      linear-gradient(180deg, ${rgba(
        props.theme.color.whiteFull,
        0.15
      )} 0%, ${rgba(props.theme.color.whiteFull, 0.15735)} 6.67%, ${rgba(
            props.theme.color.whiteFull,
            0.180184
          )} 13.33%, ${rgba(props.theme.color.whiteFull, 0.219411)} 20%, ${rgba(
            props.theme.color.whiteFull,
            0.2753
          )} 26.67%, ${rgba(
            props.theme.color.whiteFull,
            0.347009
          )} 33.33%, ${rgba(props.theme.color.whiteFull, 0.432101)} 40%, ${rgba(
            props.theme.color.whiteFull,
            0.526288
          )} 46.67%, ${rgba(
            props.theme.color.whiteFull,
            0.623712
          )} 53.33%, ${rgba(props.theme.color.whiteFull, 0.717899)} 60%, ${rgba(
            props.theme.color.whiteFull,
            0.802991
          )} 66.67%, ${rgba(
            props.theme.color.whiteFull,
            0.8747
          )} 73.33%, ${rgba(props.theme.color.whiteFull, 0.930589)} 80%, ${rgba(
            props.theme.color.whiteFull,
            0.969817
          )} 86.67%, ${rgba(props.theme.color.whiteFull, 0.99265)} 93.33%, ${
            props.theme.color.whiteFull
          } 100%),
      linear-gradient(256.01deg, ${rgba(
        props.theme.color.whiteFull,
        0.075
      )} 44.8%, ${rgba(props.theme.color.whiteFull, 0.078675)} 47.31%, ${rgba(
            props.theme.color.whiteFull,
            0.090092
          )} 49.81%, ${rgba(
            props.theme.color.whiteFull,
            0.1097055
          )} 52.32%, ${rgba(
            props.theme.color.whiteFull,
            0.13765
          )} 54.82%, ${rgba(
            props.theme.color.whiteFull,
            0.1735045
          )} 57.33%, ${rgba(
            props.theme.color.whiteFull,
            0.2160505
          )} 59.83%, ${rgba(
            props.theme.color.whiteFull,
            0.263144
          )} 62.34%, ${rgba(
            props.theme.color.whiteFull,
            0.311856
          )} 64.84%, ${rgba(
            props.theme.color.whiteFull,
            0.3589495
          )} 67.35%, ${rgba(
            props.theme.color.whiteFull,
            0.4014955
          )} 69.85%, ${rgba(
            props.theme.color.whiteFull,
            0.43735
          )} 72.36%, ${rgba(
            props.theme.color.whiteFull,
            0.4652945
          )} 74.86%, ${rgba(
            props.theme.color.whiteFull,
            0.4849085
          )} 77.37%, ${rgba(props.theme.color.whiteFull, 0.496325)} 79.87%, ${
            props.theme.color.whiteFull
          } 82.38%),
      linear-gradient(89.96deg, ${props.theme.color.whiteFull} 1.34%, ${rgba(
            props.theme.color.whiteFull,
            0
          )} 50.03%)
    `
        : `
      linear-gradient(180deg, ${rgba(
        props.theme.color.blackFull,
        0.15
      )} 0%, ${rgba(props.theme.color.blackFull, 0.15735)} 6.67%, ${rgba(
            props.theme.color.blackFull,
            0.180184
          )} 13.33%, ${rgba(props.theme.color.blackFull, 0.219411)} 20%, ${rgba(
            props.theme.color.blackFull,
            0.2753
          )} 26.67%, ${rgba(
            props.theme.color.blackFull,
            0.347009
          )} 33.33%, ${rgba(props.theme.color.blackFull, 0.432101)} 40%, ${rgba(
            props.theme.color.blackFull,
            0.526288
          )} 46.67%, ${rgba(
            props.theme.color.blackFull,
            0.623712
          )} 53.33%, ${rgba(props.theme.color.blackFull, 0.717899)} 60%, ${rgba(
            props.theme.color.blackFull,
            0.802991
          )} 66.67%, ${rgba(
            props.theme.color.blackFull,
            0.8747
          )} 73.33%, ${rgba(props.theme.color.blackFull, 0.930589)} 80%, ${rgba(
            props.theme.color.blackFull,
            0.969817
          )} 86.67%, ${rgba(props.theme.color.blackFull, 0.99265)} 93.33%, ${
            props.theme.color.blackFull
          } 100%),
      linear-gradient(256.01deg, ${rgba(
        props.theme.color.blackFull,
        0.075
      )} 44.8%, ${rgba(props.theme.color.blackFull, 0.078675)} 47.31%, ${rgba(
            props.theme.color.blackFull,
            0.090092
          )} 49.81%, ${rgba(
            props.theme.color.blackFull,
            0.1097055
          )} 52.32%, ${rgba(
            props.theme.color.blackFull,
            0.13765
          )} 54.82%, ${rgba(
            props.theme.color.blackFull,
            0.1735045
          )} 57.33%, ${rgba(
            props.theme.color.blackFull,
            0.2160505
          )} 59.83%, ${rgba(
            props.theme.color.blackFull,
            0.263144
          )} 62.34%, ${rgba(
            props.theme.color.blackFull,
            0.311856
          )} 64.84%, ${rgba(
            props.theme.color.blackFull,
            0.3589495
          )} 67.35%, ${rgba(
            props.theme.color.blackFull,
            0.4014955
          )} 69.85%, ${rgba(
            props.theme.color.blackFull,
            0.43735
          )} 72.36%, ${rgba(
            props.theme.color.blackFull,
            0.4652945
          )} 74.86%, ${rgba(
            props.theme.color.blackFull,
            0.4849085
          )} 77.37%, ${rgba(props.theme.color.blackFull, 0.496325)} 79.87%, ${
            props.theme.color.blackFull
          } 82.38%),
      linear-gradient(89.96deg, ${props.theme.color.blackFull} 1.34%, ${rgba(
            props.theme.color.blackFull,
            0
          )} 50.03%)
    `};
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    content: '';
  }
`;

export default translate(MyS4CForgotPasswordUpdate);
